import { ConnectorType } from "./ConnectorsType";

export const CONNECTORS_COMPATIBLE_CONNECTOR_WALLET: ConnectorType[] = [
    ConnectorType.ORCHESTRA
]

export const CONNECTOR_CREDIT_WALLET_ITEM = "CONNECTOR_CREDIT_WALLET_ITEM";